import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@/lib/apiClient';
import type { MutationOptions } from '@/lib/reactQuery';
import type { DateString } from '@/types/api';
import type { Appointment } from '@/types/scheduling';

export interface RescheduleAppointmentBody {
  appointmentId: string;
  studentId: number;
  enrollmentId: number;
  targetDate: DateString;
}

export interface RescheduleAppointmentResponse {
  booked_appointments: Appointment[];
}

export const rescheduleAppointment = async (data: RescheduleAppointmentBody): Promise<RescheduleAppointmentResponse> => {
  const response = await apiClient.post<RescheduleAppointmentResponse>('/v1/scheduling/reschedule-appointment', data);
  return response.data;
};

interface UseRescheduleAppointmentOptions {
  options?: MutationOptions<RescheduleAppointmentResponse, RescheduleAppointmentBody>;
}

export const useRescheduleAppointment = ({ options }: UseRescheduleAppointmentOptions = {}) => {
  return useMutation({
    mutationKey: ['rescheduleAppointment'],
    mutationFn: rescheduleAppointment,
    ...options,
  });
};
